export default __webpack_public_path__ + "images/c2b90a2e77eb65a1059bef954b4d738a-basketball_small.webp";